import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";

/*
 *  My Information Change Services
 * !== 나의 정보 수정 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/acrdt/lgn`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/usr/info/pwdchg`,
    nodes: [],
};

export const URLS = {};

export const APIS = {
    // My Information inquiry !== 나의 정보 조회 ==!
    getMyInfo: (langCd: any) => {
        return api.get(`${BASE.api}`, { ...langCd });
    },
    // Save Password !== 비밀번호 변경 ==!
    savePwd: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },
};

export const SF_USR_APLY_INFO: TFormSchema = {
    id: "form_usrAplyInfo",
    schema: {
        usrIdntfNo: { type: "text", label: "L_TIN_NO", edit: false },
        usrNm: { type: "text", label: "L_USR_NM", edit: false },
        frgnrYn: {
            type: "radio",
            label: "L_FRGNR_YN",

            options: [
                { label: "Citizen", value: "N" },
                { label: "Foreigner", value: "Y" },
            ],
            defaultValue: "N",
        },
        aplcCntyCd: { type: "code", label: "L_APLC_CNTY_CD", area: "cntyCd", popupSize: "md" },
        usrMoblNo: { type: "text", label: "L_USR_MOBL_NO" },
        usrEmlAddr: {
            type: "text",
            label: "L_USR_EML_ADDR",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.osc.00101" },
            controlSize: 10,
        },
        rsdtAddr: { type: "text", label: "L_RSDT_ADDR", controlSize: 10 },
        usrPwd: {
            type: "password",
            label: "L_NEW_PWD",
            required: true,
            pattern: {
                value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{10,}$/,
                message: "msg.osc.00225",
            },
        },
        usrPwdCfrm: {
            type: "password",
            label: "L_NEW_PWD_CFRM",
            required: true,
            pattern: {
                value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{10,}$/,
                message: "msg.osc.00225",
            },
        },
        aprvYn: { type: "text", label: "L_APRV_YN" },
        rtrnRsn: { type: "textarea", label: "L_RTRN_RSN", controlSize: 10, rows: 5 },
        prevUsrAplyId: { type: "text", label: "L_PRE_XTRN_USR_APLY_ID" },
        lgnTp: { type: "text", label: "L_LGN_TP" },
        coRppnYn: { type: "text", label: "L_CO_RPPN_YN" },
        curPwdCfrm: { type: "password", label: "L_CUR_PWD", required: true },
    },
};

export const SF_LCNE_USR_INFO: TFormSchema = {
    id: "form_lcneUsrInfo",
    schema: {
        lcneCoAplyId: { type: "text", label: "L_LCNE_CO_APLY_ID" },
        coTin: { type: "text", label: "L_CO_TIN", required: true, edit: false },
        coNm: { type: "text", label: "L_CO_NM", required: true, edit: false },
        rprsTelno: { type: "text", label: "L_RPRS_TELNO" },
        rprsFaxNo: { type: "text", label: "L_RPRS_FAX_NO" },
        rprsEml: {
            type: "text",
            label: "L_RPRS_EML",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.osc.00101" },
            controlSize: 10,
            required: true,
        },
        coAddr: { type: "text", label: "L_CO_ADDR", controlSize: 10 },
        mdfyRsn: { type: "textarea", label: "L_MDFY_RSN", controlSize: 10, rows: 5 },
        coPwd: { type: "password", label: "L_CO_PWD", required: true },
        coPwdCfrm: { type: "password", label: "L_CO_PWD_CFRM", required: true },
        emlAddrValdnYn: {
            type: "select",
            label: "L_EML_ADDR_VALDN_YN",
            required: true,
            options: [
                { label: "YES", value: "Y" },
                { label: "NO", value: "N" },
            ],
        },
        preCoAplyId: { type: "text", label: "L_PRE_LCNE_CO_APLY_ID" },
        aprvId: { type: "text", label: "L_APRV_ID" },
        lcneTpCdNm: { type: "text", label: "L_LCNE_TP_CD_NM" },
        lcneCoAplcNm: { type: "text", label: "L_LCNE_CO_APLC_NM", required: true },
        rtrnRsn: { type: "textarea", label: "L_RTRN_RSN", controlSize: 10, rows: 5 },
        bsopPrcssStat: { type: "text", label: "L_BSOP_PRCSS_STAT" },
        lastLcneCoAplyId: { type: "text", label: "L_LAST_LCNE_CO_APLY_ID" },
        curPwdCfrm: { type: "password", label: "L_CUR_PWD" },
    },
};
